import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pb-10" }
const _hoisted_2 = {
  class: "anchor fw-bolder mb-5",
  id: "overview"
}
const _hoisted_3 = { class: "py-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://getbootstrap.com/docs/5.0/utilities/api/",
  class: "fw-bold"
}, "Bootstrap Utility API", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("code", null, "src/sass/_utilities.scss", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("code", null, "src/sass/_variables.scss", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("code", null, "src/sass/_variables.custom.scss", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/documentation/utilities#overview" }),
      _createTextVNode(" Overview ")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("b", null, _toDisplayString(_ctx.themeName), 1),
      _createTextVNode(" fully utilizes the "),
      _hoisted_4,
      _createTextVNode("  in "),
      _hoisted_5,
      _createTextVNode(" to generate additional utility classes to cover its own design system. The customized utility SASS variables are defined in "),
      _hoisted_6,
      _createTextVNode(" and in "),
      _hoisted_7,
      _createTextVNode(" you can override any variable for your needs. ")
    ])
  ]))
}